import { apiFetch, ApiError } from "./client";

export interface SessionUser {
  id: string;
  email: string;
  name?: string;
}

export interface SessionState {
  user: SessionUser | null;
}

export async function getSession(): Promise<SessionState> {
  try {
    const data = await apiFetch<{ user: SessionUser | null } | null>(
      "/api/auth/get-session",
    );
    return { user: data?.user ?? null };
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) return { user: null };
    throw e;
  }
}

export async function signInEmail(email: string, password: string) {
  return apiFetch("/api/auth/sign-in/email", {
    method: "POST",
    json: { email, password },
  });
}

export async function signUpEmail(email: string, password: string, name: string) {
  return apiFetch("/api/auth/sign-up/email", {
    method: "POST",
    json: { email, password, name },
  });
}

export async function signOut() {
  return apiFetch("/api/auth/sign-out", { method: "POST" });
}
